import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type {
  FontSizeProps,
  FontWeightProps,
  LineHeightProps,
  SpaceProps,
  TextAlignProps,
} from 'styled-system';
import { color, fontSize, fontWeight, lineHeight, space, textAlign } from 'styled-system';

import type { ColorProps } from '../theme/system-types';

export type TextProps = FontSizeProps &
  FontWeightProps &
  LineHeightProps &
  TextAlignProps &
  ColorProps &
  SpaceProps;

const UnstyledText = styled.div<TextProps>(
  fontSize,
  lineHeight,
  textAlign,
  fontWeight,
  color,
  space
);

/** @deprecated Use Typography components */
export const Text = (props: ComponentProps<typeof UnstyledText>) => (
  <UnstyledText color="sys.neutral.text.default" fontSize={3} lineHeight={3} {...props} />
);

const UnstyledBigHeading = styled.div<TextProps>(
  fontSize,
  lineHeight,
  textAlign,
  fontWeight,
  color,
  space
);

/** @deprecated Use Typography components */
export const BigHeading = (props: ComponentProps<typeof UnstyledBigHeading>) => (
  <UnstyledBigHeading
    color="sys.neutral.text.strong"
    textAlign="center"
    fontSize={['fs_24', null, 'fs_32']}
    lineHeight={['lh_32', null, 'lh_40']}
    fontWeight="bold"
    {...props}
  />
);

const UnstyledHeading = styled.div<TextProps>`
  ${fontSize};
  ${lineHeight};
  ${textAlign};
  ${fontWeight};
  ${color};
  ${space};
`;

/** @deprecated Use Typography components */
export const Heading = (props: ComponentProps<typeof UnstyledHeading>) => (
  <UnstyledHeading
    color="sys.neutral.text.default"
    fontSize={['fs_16', null, 'fs_24']}
    lineHeight={['lh_24', null, 'lh_32']}
    fontWeight="bold"
    {...props}
  />
);

const UnstyledSmallHeading = styled.div<TextProps>(
  fontSize,
  lineHeight,
  textAlign,
  fontWeight,
  color,
  space
);

/** @deprecated Use Typography components */
export const SmallHeading = (props: ComponentProps<typeof UnstyledSmallHeading>) => (
  <UnstyledSmallHeading
    color="sys.neutral.text.default"
    fontSize={['fs_14', null, 'fs_16']}
    lineHeight="lh_24"
    fontWeight="bold"
    {...props}
  />
);
